var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48058 4.21859C4.62115 4.07802 4.80884 3.99927 5.00829 4.00001L11.7552 4.00077C11.9546 4.00004 12.1416 4.07805 12.2821 4.21862C12.4227 4.35918 12.5007 4.54612 12.5 4.74556V11.4927C12.5007 11.6922 12.4227 11.8791 12.2821 12.0197C12.1416 12.1603 11.9546 12.2383 11.7552 12.2375C11.5557 12.2383 11.3688 12.1603 11.2274 12.019C11.0869 11.8784 11.0089 11.69 11.0089 11.4913V6.54572L4.77263 12.7813C4.48118 13.0728 4.00867 13.0728 3.71795 12.7821C3.42723 12.4914 3.42723 12.0189 3.71868 11.7274L9.95491 5.49182L5.00829 5.49105C4.8103 5.49179 4.62336 5.41525 4.48205 5.27395C4.34074 5.13264 4.26272 4.94572 4.26272 4.74553C4.26125 4.54682 4.34 4.35915 4.48058 4.21859Z",
    fill: "#1345AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.e7faa7b1c1f9e180f64161dcd1694ce1.svg";
export { ForwardRef as ReactComponent };